import { call, put, takeLatest } from 'redux-saga/effects';
import * as types from '../../../actions/index.types';
import * as req from '../../../../axios/request/SocietyPortal/DashboardReqs/DashboardReqs';

function* getSocietyDashboard(action) {
    try {
        const result = yield call(req.getSocietyDashboardReq, action);
        if (result?.success === true) {
            yield put({ type: types.GET_SOCIETY_DASHBOARD_SUCCESS, payload: result.data });
        } else {
            yield put({ type: types.GET_SOCIETY_DASHBOARD_FAILURE, message: result?.message });
        }
    } catch (e) {
        yield put({ type: types.GET_SOCIETY_DASHBOARD_FAILURE, message: e?.message });
    }
}

function* getOperationsDashboard(action) {
    try {
        const result = yield call(req.getOperationsDashboardReq, action);
        if (result?.success === true) {
            yield put({ type: types.GET_OPERATIONS_DASHBOARD_SUCCESS, payload: result.data });
        } else {
            yield put({ type: types.GET_OPERATIONS_DASHBOARD_FAILURE, message: result?.message });
        }
    } catch (e) {
        yield put({ type: types.GET_OPERATIONS_DASHBOARD_FAILURE, message: e?.message });
    }
}

export default function* dashboardSaga() {
    yield takeLatest(types.GET_SOCIETY_DASHBOARD, getSocietyDashboard);
    yield takeLatest(types.GET_OPERATIONS_DASHBOARD, getOperationsDashboard);
}
